import { Tabs as MTabs } from '@mantine/core';
import classes from './tabs.module.scss';

export const Tabs = MTabs.extend({
  classNames: classes,
});
